import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Phone } from "react-bootstrap-icons";
import "react-confirm-alert/src/react-confirm-alert.css";
import Select from "react-select";
import { toast } from "react-toastify";
import * as Actions from "../../constants/baseUrl";
import CampaignRelations from "../dynamicRelationFieldSet/campaignRelations";
import CustomLoader from "../loader/loader";
import SubDomainRouter from "../subDomainRouter/subDomainRouter";
import TokenDetails from "../useUserDetails/useTokenDetails";

const SMSCampaign = () => {
  const myToken = localStorage.getItem("token");
  const tokenDetails = TokenDetails();
  const myUserId = tokenDetails?.Email;
  const title = SubDomainRouter("title");

  const [loading, setLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [step, setStep] = useState(1);
  const [phoneLists, setSMSLists] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState([]);
  const [relationData, setRelationData] = useState(
    [{ type: "", value: "" }] || []
  );
  const [formData, setFormData] = useState({
    campaign_name: "SMS campaign",
    description: "My Campaign Description",
    userId: myUserId,
    type: "campaign",
    smslists: [],
    entityRelation: [],
    subject: `${title} whatsapp campaign starts`,
  });
  const [selectedSMSList, setSelectedSMSList] = useState([]);
  const [whatsappContacts, setSMSContacts] = useState([]);

  const handleFieldChange = (fieldName, fieldValue) => {
    const newState = {
      ...formData,
      [fieldName]: fieldValue,
    };

    setFormData(newState);
  };

  // Get SMSLists
  const getSMSLists = () => {
    axios
      .get(`${Actions.BASE_URL}smsLists/users/${myUserId}`, {
        headers: {
          Authorization: "Bearer " + myToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setSMSLists(res.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong. Please Try again later.", {
          autoClose: 3000,
          hideProgressBar: true,
          draggable: true,
        });
      });
  };

  const handleSMSListSelection = (selectedListName) => {
    setSelectedSMSList(selectedListName);
  };

  const getContactsForList = async (listID) => {
    try {
      await axios
        .get(`${Actions.BASE_URL}contacts/${myUserId}/smslist/${listID}`, {
          headers: {
            Authorization: "Bearer " + myToken,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // Extract contacts from the response and add unique contacts to the array
          const contactsForList = response.data;
          contactsForList.forEach((contact) => {
            setSMSContacts((prevContacts) => {
              // Check for existing contact based on ID
              const existingContact = prevContacts.find(
                (c) => c.id === contact.id
              );

              // Only add the contact if it doesn't exist in the array
              if (!existingContact) {
                return [...prevContacts, contact];
              }

              return prevContacts;
            });
          });
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.error(error.response);
    }
  };

  const fetchContactsForAllLists = async () => {
    // Clear existing contacts before fetching for new lists
    setSMSContacts([]);

    // Iterate through each selected SMS list
    for (const listID of selectedSMSList) {
      await getContactsForList(listID);
    }
  };

  useEffect(() => {
    fetchContactsForAllLists();
  }, [selectedSMSList]);

  // Steps
  const handleNext = async () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = () => {
    const data = {
      ...formData,
      entityRelation: relationData,
      smslists: [...selectedSMSList],
    };

    axios
      .post(`${Actions.BASE_URL}campaigns`, data, {
        headers: {
          Authorization: "Bearer " + myToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLoadingProgress(false);
      })
      .catch((error) => {
        setLoadingProgress(false);
        console.log(error.response);
      });
  };

  // Call Req fun initially
  useEffect(() => {
    getSMSLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const coursesAlias = SubDomainRouter("coursesAlias");
  const demosAlias = SubDomainRouter("demosAlias");

  return (
    <Container fluid="lg" className="formMain create p-0 demosEditSection">
      {loadingProgress ? (
        <>
          <span className="register-loader"> </span>
          <span className="spinnerOverlay"></span>
        </>
      ) : null}
      <div className="demosAddFormHeader text-center">
        <h2 className="addFormHeading theme-text-2">SMS Campaign</h2>
        <div className="demosEditHeader text-center my-3 mb-lg-5">
          <ul className="demosEditList">
            <li>
              <button
                className={`stepstriggers ${step === 1 ? "active" : null}`}
                onClick={() => setStep(1)}
              >
                <span>1 </span>
              </button>
            </li>
            <li>
              <button
                className={`stepstriggers ${step === 2 ? "active" : null}`}
                onClick={() => setStep(2)}
              >
                <span>2</span>
              </button>
            </li>
            <li>
              <button
                className={`stepstriggers ${step === 3 ? "active" : null}`}
                onClick={() => setStep(3)}
                disabled={selectedSMSList?.length === 0}
              >
                <span>3</span>
              </button>
            </li>
            <li>
              <button
                className={`stepstriggers ${step === 4 ? "active" : null}`}
                onClick={() => setStep(4)}
                disabled={selectedSMSList?.length === 0}
              >
                <span>4</span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        {/* Step 1 */}
        <Row className={`mx-0 ${step === 1 ? "d-block" : "d-none"}`}>
          <Col md={12} className="d-flex justify-content-between gap-3">
            <h5 className="theme-text flex-grow-1">
              Select relevant course(s) or demo(s)
            </h5>
            <Button
              className="clickable add-button mb-2 ms-auto d-flex"
              onClick={() => {
                const newField = { type: "", value: "" };
                setRelationData([...relationData, newField]);
              }}
            >
              <span className="addBttn d-block">+</span>
            </Button>
          </Col>
          <hr />
          <Col md={12}>
            {relationData?.map((field, index) => (
              <CampaignRelations
                key={index}
                fields={relationData}
                field={field}
                index={index}
                onEntityDetailsChange={(selectedItems) => {
                  setSelectedItemDetails(selectedItems);
                }}
                onFieldChange={(newFields) => {
                  setRelationData(newFields);
                }}
                fieldLabels={{
                  valueInput: "Select An Entity",
                }}
                selectOptions={[
                  { value: "demo", label: demosAlias },
                  { value: "course", label: coursesAlias },
                ]}
              />
            ))}
          </Col>
          <Col md={12} className="mt-3">
            <Button
              type="button"
              onClick={handleNext}
              className="next demosEditBtn w-auto"
            >
              Next
            </Button>
          </Col>
        </Row>
        {/* step2 */}
        <Row className={`mx-0 ${step === 2 ? "d-block" : "d-none"}`}>
          <Col md={12}>
            <h5 className="theme-text mb-2">Select SMS Lists & Add Message</h5>
          </Col>
          <hr />

          <Col md={12}>
            <small className="text-end d-block text-dark">
              required<span className="text-danger">*</span>
            </small>
            <Form.Group className="form-floating mb-3">
              <Select
                className="text-capitalize form-control select-email"
                required
                isMulti
                placeholder="Select an existing email list"
                options={phoneLists?.map((email) => ({
                  value: email.id,
                  label: email.list_name,
                }))}
                onChange={(selectedOptions) =>
                  handleSMSListSelection(
                    selectedOptions
                      ? selectedOptions?.map((option) => option.value)
                      : []
                  )
                }
              />
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="form-floating mb-3">
              <Form.Control
                as={"textarea"}
                rows={"4"}
                placeholder="body_plain_text"
                className="form-control max-h-auto"
                name="body_plain_text"
                value={formData?.body_plain_text}
                id="body_plain_text"
                onChange={(e) =>
                  handleFieldChange("body_plain_text", e.target.value)
                }
              />
              <Form.Label className="form-label" htmlFor="body_plain_text">
                Your Message
              </Form.Label>
            </Form.Group>
          </Col>
          <Col md={12} className="mt-3">
            <Button
              type="button"
              className="previous-button demosEditBtn"
              onClick={handlePrevious}
            >
              Previous
            </Button>
            <Button
              type="submit"
              disabled={selectedSMSList?.length === 0}
              onClick={handleNext}
              className="next demosEditBtn"
            >
              Next
            </Button>
          </Col>
        </Row>
        {step === 3 && (
          <Row className="mx-0">
            <Col md={12}>
              <h5 className="theme-text mb-2">Send Message To Your Contacts</h5>
            </Col>
            <hr />
            {}
            {loading ? (
              <CustomLoader />
            ) : (
              <>
                {whatsappContacts?.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className="bg-theme bg-opacity-50 text-light">
                          First Name
                        </th>
                        <th className="bg-theme bg-opacity-50 text-light">
                          Last Name
                        </th>
                        <th className="bg-theme bg-opacity-50 text-light">
                          SMS
                        </th>
                        <th className="bg-theme bg-opacity-50 text-light text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {whatsappContacts?.map((contact, index) => (
                        <tr key={index}>
                          <td>{contact.first_name}</td>
                          <td>{contact.last_name}</td>
                          <td>{contact.phone}</td>
                          <td className="d-flex align-items-center justify-content-center gap-3">
                            <a
                              target="_blank"
                              href="#"
                              rel="noreferrer"
                              className="text-decoration-none d-flex align-items-center text-dark"
                            >
                              <Phone />
                              &nbsp;Send
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p>⚠An error occurred!</p>
                )}
              </>
            )}
            <Col md={12} className="mt-3">
              <Button
                type="button"
                className="previous-button demosEditBtn w-auto"
                onClick={handlePrevious}
              >
                Previous
              </Button>
            </Col>
          </Row>
        )}
      </Form>
    </Container>
  );
};

export default SMSCampaign;
